import * as React from "react";
function SvgSpeedsearchQueryPlaceholder(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 553.53 86.08"
      ref={svgRef}
      {...props}
    >
      <circle cx={69.53} cy={39} r={25} fill="currentColor" />
      <path
        strokeLinecap="round"
        strokeWidth={26}
        stroke="currentColor"
        d="M119.53 39h228"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSpeedsearchQueryPlaceholder);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
